import { initializeApp } from 'firebase/app';
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCiuenc1NTIuQ6IBWlyDCN_3srE-wDUM_0",
  authDomain: "game-app-779fb.firebaseapp.com",
  projectId: "game-app-779fb",
  storageBucket: "game-app-779fb.appspot.com",
  messagingSenderId: "741410979750",
  appId: "1:741410979750:web:7f2c66b61e734d6457d967",
  measurementId: "G-HYEZCHS25G"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
getAuth(app);
getFirestore(app);

export const secondApp = initializeApp(firebaseConfig, 'second');